module.exports = __webpack_public_path__ + "static/media/carousalTwo.c6df4aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/carousalTwo.jpg
// module id = 15
// module chunks = 0